export const xs = "0.7rem"

export const sm = "0.875rem"

export const md = "1rem"

export const lg = "1.25rem"

export const xl = "1.4rem"

export const xxl = "1.55rem"
